<!-- <nb-card >
    <nb-card-header class="title-dialog">
        <button type="button" class="close float-right" size="small" (click)="closeSeguro()">&times;</button>
        <h3 style="color: white;">Guardar Cambios - Seguros</h3>
    </nb-card-header>
    <nb-card-body style="text-align: center;">
        <h3>¿Esta seguro que desea guardar todos los cambios realizados?</h3>
        <br>
        <div style="float: left;">
            <button nbButton size="small" class="buttontz" (click)="closeSeguro()">Cancelar</button>
        </div>
        <div style="float: right;">
            <div>
                <app-spinner style="margin-right: 20px; margin-top: 3px;" *ngIf="showSpinner"></app-spinner>
            </div>
            <button nbButton size="small"  class="buttontz" [hidden]="hiddenBtn" (click)="guardarSeguros()">Guardar</button>
        </div>
    </nb-card-body>
</nb-card> -->

<!-- <h3 style="color: white;">Guardar Cambios - Seguros</h3>
<h3>¿Esta seguro que desea guardar todos los cambios realizados?</h3>
<br>
<div style="float: left;">
    <button mat-button class="buttontz" (click)="guardarSeguros(false)">Cancelar</button>
</div>
<div style="float: right;">
    <button mat-button class="buttontz" (click)="guardarSeguros(true)">Guardar</button>
</div> -->

<mat-card style="background-color: #007749;"><h3 style=" color: white;">Guardar Cambios - Seguros</h3></mat-card>
<mat-card style="height: 120px;">
    <mat-card-content>
        <h3>¿Esta seguro que desea guardar todos los cambios realizados?</h3>
    </mat-card-content>
    <mat-card-actions>
      <div style="float: left;">
          <button mat-button class="buttontz" (click)="guardarSeguros(false)"  >Cancelar</button>
      </div>
      <div style="float: right;">
          <button mat-button class="buttontz" (click)="guardarSeguros(true)">Guardar</button>
      </div>
    </mat-card-actions>
</mat-card>
